


































































































































































































































import { Mixins, Component, Watch } from "vue-property-decorator";
import api from "../../api/index";
import Box from "../components/Box.vue";
import Lists from "../components/Lists.vue";
import { Getter } from "vuex-class";
import {perPageOptions} from '@/constants/ListOptions'

import Map from "../components/Map.vue";
import ConfirmModal from "../components/ConfirmModal.vue";

@Component({
	components: {
		Box,
		Map,
		ConfirmModal,
	},
})
export default class AccessPointProfile extends Mixins(Lists) {
	accessPoint = {
		id: null,
		uuid: null,
	};

	perPageOptions = perPageOptions

	accessPointEvents: any = [];
	accessPointEventsPerPage = 5;
	accessPointEventsTotalPages = 0;
	accessPointEventsCurrentPage = 1;
	accessPointEventsTotalResults = 0;

	accesses = [];
	accessWordSearched = "";
	accessesTotalPages = 0;
	accessesCurrentPage = 1;
	accessesPerPage = 10;
	accessesTotalResults = 0;

	openings = [];
	openingsTotalPages = 0;
	openingsCurrentPage = 1;
	openingsPerPage: number = Number(localStorage.getItem('resultsPerListPage')) || this.perPageOptions[0];
	openingsTotalResults = 0;
	openingsExported = false;

	mapIsOpen = true;
	openMaps: any = [];
	loading = false;
	userLoading = false;

	confirmModalActive = false;

	command = null;

	@Getter("user") user: any;
	@Getter("admin") admin: any;

	async mounted() {
		await api.setToken();
		await this.getAccessPoint();
		await this.getAccessPointAccesses();
		await this.getAccessPointOpenings();
		// @ts-ignore
		if (this.admin && this.accessPoint.remotely_openable)
			await this.getAccessPointEvents();
		this.addAccessPointIdInBreadcrumb();
	}

	async getAccessPoint() {
		try {
			const res = await api.get(
				"bo/access_points/" + this.$route.params.accessPointId
			);
			this.accessPoint = res.data;
			// @ts-ignore
			if (this.accessPoint.condominiums)
				// @ts-ignore
				this.openMaps.push(this.accessPoint.condominiums[0].id);
		} catch (e) {
			if (e.response.status === 401) {
				console.log(e.response.status);
			}
		}
	}

	async getAccessPointEvents(pageNumber?: number) {
		try {
			const res = await api.get(
				"bo/access_points/" + this.$route.params.accessPointId + "/events",
				{
					params: {
						page: pageNumber,
						per_page: this.accessPointEventsPerPage,
					},
				}
			);
			this.accessPointEventsTotalPages = parseInt(
				res.headers["x-pagination-total-pages"]
			);
			this.accessPointEventsCurrentPage = parseInt(
				res.headers["x-pagination-page"]
			);
			this.accessPointEventsPerPage = parseInt(
				res.headers["x-pagination-per-page"]
			);
			this.accessPointEventsTotalResults = parseInt(
				res.headers["x-pagination-total"]
			);
			this.accessPointEvents = [...res.data];
		} catch (e) {
			console.log(e);
		}
	}

	async resetAccess() {
		try {
			await api.post(
				"bo/access_points/" + this.$route.params.accessPointId + "/rescue"
			);
			this.$toast.open({
				message: "Le boîtier vient d'être réinitialisé",
				type: "is-info",
				duration: 5000,
			});
		} catch (error) {
			this.$toast.open({
				message: "Le boîtier n'a pas pu être réinitialisé",
				type: "is-danger",
				duration: 5000,
			});
			console.log(error);
		}
	}

	async sendCommand() {
		if (!this.command) return;
		try {
			const command = {
				type: this.command,
			};
			await api.post(
				"bo/access_points/" + this.$route.params.accessPointId + "/commands",
				{ command }
			);
			await this.getAccessPointEvents();
			this.$toast.open({
				message: "La commande vient d'être effectuée avec succès",
				type: "is-info",
				duration: 5000,
			});
			this.command = null;
		} catch (error) {
			this.command = null;
			this.$toast.open({
				message: "La commande n'a pas pu effectuer",
				type: "is-danger",
				duration: 5000,
			});
			console.log(error);
		}
	}

	isOpenMap(id) {
		return this.openMaps.includes(id);
	}

	closeMap(id) {
		this.openMaps.splice(this.openMaps.indexOf(id), 1);
	}

	openMap(id) {
		this.openMaps.push(id);
	}

	@Watch("accessesPerPage")
  @Watch("accessWordSearched")
  onSearchPropsChanged(val: any, old: any) {
    if (old && val && val.toString() === old.toString()) {
      return
    }
    this.getAccessPointAccesses();
  }

	async getAccessPointAccesses(pageNumber?: number) {
		try {
			const res = await api.get(
				`bo/access_points/${this.$route.params.accessPointId}/groups`,
				{
					params: {
						page: pageNumber,
						per_page: this.accessesPerPage,
						keywords: this.accessWordSearched,
					},
				}
			);
			this.accessesTotalPages = parseInt(res.headers["x-pagination-total-pages"]);
			this.accessesCurrentPage = parseInt(res.headers["x-pagination-page"]);
			this.accessesPerPage = parseInt(res.headers["x-pagination-per-page"]);
			this.accessesTotalResults = parseInt(res.headers["x-pagination-total"]);

			this.accesses = res.data;
		} catch (e) {
			if (e.response.status === 401) {
				console.log(e.response.status);
			}
		}
	}

	@Watch("openingsPerPage")
	updateResults2() {
    localStorage.setItem('resultsPerListPage', this.openingsPerPage.toString())
		this.getAccessPointOpenings();
	}

	async getAccessPointOpenings(pageNumber?: number) {
		try {
			const res = await api.get(
				`bo/access_points/${this.$route.params.accessPointId}/openings`,
				{
					params: {
						page: pageNumber,
						per_page: this.openingsPerPage,
					},
				}
			);
			this.openingsTotalPages = parseInt(res.headers["x-pagination-total-pages"]);
			this.openingsCurrentPage = parseInt(res.headers["x-pagination-page"]);
			this.openingsTotalResults = parseInt(res.headers["x-pagination-total"]);

			this.openings = res.data;
		} catch (e) {
			if (e.response.status === 401) {
				console.log(e.response.status);
			}
		}
	}

  async exportOpenings() {
    try {
      const res = await api.get(
        `bo/access_points/${this.$route.params.accessPointId}/openings.csv`,
        {
          headers: {
            'Content-Type': 'text/csv'
          },
          data: {}
        }
      )
      this.$toast.open({
        message: "Vous allez recevoir le compte-rendu d'horodatage sur votre adresse email.",
        type: "is-novaccess-purple",
        duration: 2000,
      });
    } catch (e) {
      this.$toast.open({
        message: "Une erreur est survenue dans l'export du compte-rendu d'horodatage",
        type: "is-danger",
        duration: 2000,
      });
    }
  }

	goToAccess(accessId: any) {
		this.$router.push({ name: "accessProfile", params: { accessId } });
	}

	addAccessPointIdInBreadcrumb() {
		if (!this.accessPoint.uuid) return;
		const crumb: any = document.querySelector(".breadcrumb .is-current");
		crumb.innerHTML = `Boitier ${this.accessPoint.uuid}`;
	}
}
